import { header } from './header.js'
import { section01 } from './section01.js'
import { section02 } from './section02.js'
import { section03 } from './section03.js'
import { section04 } from './section04.js'
import { section05 } from './section05.js'
import { section06 } from './section06.js'
import { section07 } from './section07.js'
import { section08 } from './section08.js'
import { section09 } from './section09.js'


window.addEventListener("DOMContentLoaded", (event) => {
    let windowWidth = window.innerWidth
    let windowHeight = window.innerHeight
    window.addEventListener("resize", (event) => {
        windowWidth = window.innerWidth
        windowHeight = window.innerHeight

        // re-init functions on resize
        section02(windowWidth)
        section04(windowHeight) // Naming + Logo Section
        section05(windowWidth)
        section06(windowHeight)
        section08(windowHeight) // Brand Story Section
        section09(windowHeight)
    })
    
    if (windowWidth < 900) {
       var navbarAnim = gsap.from('header#site-header', { 
          yPercent: -100,
          paused: true,
          duration: 0.2,
          ease: "power2.inOut",
       }).progress(1);
 
       window.addEventListener('scroll', (event) => {
          let scrolledY = window.scrollY;
          if ( scrolledY >= 100 ) {
             navbarAnim.reverse();
          } else {
             navbarAnim.play();
          }
       });
    }

    header()
    section01()
    section02(windowWidth)
    section03()
    section04(windowHeight) // Naming + Logo Section
    section05(windowWidth)
    section06(windowHeight)
    section07()
    section08(windowHeight) // Brand Story Section
    section09(windowHeight)
})